module.exports = __webpack_public_path__ + "static/img/001.3ecbbf91.png";